import { initializeApp, getApps } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase is now used ONLY for Cloud Messaging (FCM push notifications).
// Phone Auth has been migrated to MSG91 OTP Widget.

const firebaseConfig = {
  apiKey: "AIzaSyDKpqEDvv5guVIjkabnAHzgqn22u1y9A0M",
  authDomain: "nirmandwarauth.firebaseapp.com",
  projectId: "nirmandwarauth",
  storageBucket: "nirmandwarauth.firebasestorage.app",
  messagingSenderId: "587201749216",
  appId: "1:587201749216:web:f2c8820de3118b92477085"
};

const VAPID_KEY = "BEdSgTAKhB1Z_Jj05vrdrb6OE6LFag3w3tGpZ3CbC3ltRD-BFEtAA19wCssyVv9taHFaMp6qxtm4UM_c7UQfNN4";

let app;
try {
  app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
} catch (e) {
  console.error("Firebase init error:", e);
}

let messaging = null;
try {
  if (app && typeof window !== 'undefined' && 'Notification' in window) {
    messaging = getMessaging(app);
  }
} catch (e) {
  console.warn("Firebase Messaging not supported:", e);
}

export async function requestNotificationPermission() {
  if (!messaging) return null;
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      return token;
    }
  } catch (e) {
    console.error("Error getting FCM token:", e);
  }
  return null;
}

export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
}

export { messaging };
export default app;
